import { createSlice } from "@reduxjs/toolkit";
import {
  AddUserReportReasonAction,
  DeleteUserReportReasonAction,
  GetAllUserReportReason,
  GetAllUserReportReasonAction,
  UpdateUserReportReasonAction,
} from "store/middlewares/dataManagement/userReportReason";

// isDeleteMeFulFilled
export const userReportReasonSlice = createSlice({
  name: "userReportReason",
  initialState: {
    userReportReasonsLoading: true,
    userReportReasons: null,
    allReportReason: true,
    allReportReasonLoading: [],
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllUserReportReasonAction.pending, (state) => {
        // state.reportReasonsLoading = true;
        // state.reportReasons = null;
        state.userReportReasons =
          state.userReportReasons?.data?.length > 0
            ? state.userReportReasons
            : null;
      })
      .addCase(GetAllUserReportReasonAction.fulfilled, (state, action) => {
        state.userReportReasonsLoading = false;
        state.userReportReasons = action.payload.response;
      })
      .addCase(GetAllUserReportReasonAction.rejected, (state) => {
        state.userReportReasonsLoading = false;
        state.userReportReasons = null;
      })

      // Delete
      .addCase(DeleteUserReportReasonAction.fulfilled, (state, action) => {
        state.userReportReasonsLoading = false;
        state.userReportReasons = action.payload.response;
      })

      //Update
      .addCase(UpdateUserReportReasonAction.fulfilled, (state, action) => {
        state.userReportReasonsLoading = false;
        state.userReportReasons = {
          ...state.userReportReasons,
          data: state.userReportReasons.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item,
          ),
        };
      })

      //Add
      .addCase(AddUserReportReasonAction.fulfilled, (state, action) => {
        state.userReportReasonsLoading = false;
        state.userReportReasons = action.payload.response;
      })

      .addCase(GetAllUserReportReason.pending, (state) => {
        state.allReportReason = [];
      })
      .addCase(GetAllUserReportReason.fulfilled, (state, action) => {
        state.allReportReasonLoading = false;
        state.allReportReason = action.payload.response;
      })
      .addCase(GetAllUserReportReason.rejected, (state) => {
        state.allReportReasonLoading = false;
        state.allReportReason = [];
      });
  },
});

export default userReportReasonSlice.reducer;
